import React from 'react'
import { Button } from 'antd'
import { useHistory } from 'react-router-dom'

import PopupWrapper from './PopupWrapper'
import Images from '../../Images'
import './PopupPage.less'

function DealNotQualifiedPopupPage(props) {

  const history = useHistory();

  function handleClose() {
    history.push('/home/deals');
  }

  return (
    <PopupWrapper
      width={420}
      path={'/home/deals'}
    >
      <div className="dialog-content" style={{ padding: 40 }}>
        <img src={Images.phoneCancel} alt="" />
        <div className="dialog-title deal">Deal not qualified</div>
        <div className="deal-text">Unfortunately your deal does not qualify for being shared on IDN's platform.</div>
        <br />
        <div className="deal-text">Please contact IDN if you have questions</div>
        <div className="btn-footer">
          <Button type="primary white" className="btn-primary" onClick={handleClose}>
            Return
            </Button>
        </div>
      </div>
    </PopupWrapper>
  )
}

export default DealNotQualifiedPopupPage
